// extracted by mini-css-extract-plugin
export default {"checkBox":"PostServiceList_checkBox__tFlTn","table":"PostServiceList_table__qfhSW"};